import { render, staticRenderFns } from "./userspecialdietdetails.vue?vue&type=template&id=2fd0f16d&"
import script from "./userspecialdietdetails.vue?vue&type=script&lang=js&"
export * from "./userspecialdietdetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports